// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-availabilty-main-wrapper {
    width: 460px;
    margin: 0 auto;
    margin-top: 30px;
}

.availabilty-content-wrap{
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: -58px;
}

.availabilty-content-wrap img{
    width: 44px;
    cursor: pointer;
}

.availabilty-content-wrap h3 {
    font-size: 30px;
    color: #1A1919;
    font-weight: 700;
    margin-bottom: 0px;
    text-align: left;
}

.availabilty-content-wrapper{
    margin-bottom: 30px;
}

.availabilty-content-wrapper p{
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}


.availability-main-wrap {
    display: flex;
    align-items: baseline;
    /* flex-direction: column; */
    gap: 30px;
    margin-bottom: 15px;
}

.availability-input-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
}

.availability-day-wrap {
    width: 42px;
    height: 42px;
    background: #00A19B;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.availability-day-wrap h3 {
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    margin: 0px;
}


.availability-input-left-wrap input {
    width: 130px;
    height: 49px;
    background: #F3F3F3;
    border-radius: 13px;
    border: none;
    color: #1A1919;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    padding-left: 10px;
    padding-right: 10px;
    outline: none;
}

.availability-input-repeat {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 15px;
}


.plus-icon-wrap img, .minus-icon-wrap img  {
    width: 33px;
    cursor: pointer;
}

.availability-input-wrapper p {
    font-size: 12px;
    color: #626262;
    margin: 0px;
    font-weight: 400;
}

.signup-availibty-save-btn button{
    margin-top: 30px;
    height: 49px;
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Account/availabilty.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,qBAAqB;IACrB,4BAA4B;IAC5B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".signup-availabilty-main-wrapper {\n    width: 460px;\n    margin: 0 auto;\n    margin-top: 30px;\n}\n\n.availabilty-content-wrap{\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-left: -58px;\n}\n\n.availabilty-content-wrap img{\n    width: 44px;\n    cursor: pointer;\n}\n\n.availabilty-content-wrap h3 {\n    font-size: 30px;\n    color: #1A1919;\n    font-weight: 700;\n    margin-bottom: 0px;\n    text-align: left;\n}\n\n.availabilty-content-wrapper{\n    margin-bottom: 30px;\n}\n\n.availabilty-content-wrapper p{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n\n.availability-main-wrap {\n    display: flex;\n    align-items: baseline;\n    /* flex-direction: column; */\n    gap: 30px;\n    margin-bottom: 15px;\n}\n\n.availability-input-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.availability-day-wrap {\n    width: 42px;\n    height: 42px;\n    background: #00A19B;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.availability-day-wrap h3 {\n    font-size: 14px;\n    color: #fff;\n    font-weight: 600;\n    margin: 0px;\n}\n\n\n.availability-input-left-wrap input {\n    width: 130px;\n    height: 49px;\n    background: #F3F3F3;\n    border-radius: 13px;\n    border: none;\n    color: #1A1919;\n    font-size: 14px;\n    text-align: center;\n    font-weight: 500;\n    padding-left: 10px;\n    padding-right: 10px;\n    outline: none;\n}\n\n.availability-input-repeat {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 15px;\n}\n\n\n.plus-icon-wrap img, .minus-icon-wrap img  {\n    width: 33px;\n    cursor: pointer;\n}\n\n.availability-input-wrapper p {\n    font-size: 12px;\n    color: #626262;\n    margin: 0px;\n    font-weight: 400;\n}\n\n.signup-availibty-save-btn button{\n    margin-top: 30px;\n    height: 49px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
